import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from '@sentry/react';
import FormRenderer from "./components/FormRenderer";
import { RUNTIME_CONFIG } from './config/runtime';

//const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_BASE_URL = RUNTIME_CONFIG.apiEndpoint;

const handleFormSubmit = async (formData, serviceId, audienceId, contactDetailTimeZone, apiKey) => {
  try {
    const queryParams = new URLSearchParams(formData).toString();

    const response = await fetch(
      `${API_BASE_URL}/api/v1/contact/service/${serviceId}?api-key=${apiKey}&audienceid=${audienceId}&timezone=${contactDetailTimeZone}&${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to submit form');
    }

    const result = await response.json();
    console.log('API Response:', result);
    // alert('Form submitted successfully!');
  } catch (error) {
    console.error('Error submitting form:', error);
    // alert('Failed to submit form. Please try again.');
  }
};

window.EmbedForm = {
  init: async (config) => {
    // Handle single config or array of configs
    const configs = Array.isArray(config) ? config : [config];
    
    await Promise.all(configs.map(async ({ container, formId, serviceId, apiKey }) => {
      const formContainer = document.querySelector(container);
      if (!formContainer) {
        console.error(`Container ${container} not found!`);
        return;
      }
      
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/service/${serviceId}/form/${formId}`);
        if (!response.ok) {
          Sentry.captureReactException(response, 'Failed to fetch form');
          throw new Error(`Failed to fetch form: ${response.statusText}`);
        }

        const formJson = await response.json();
        const audienceId = formJson.data.audienceId;
        const contactDetailTimeZone = formJson.data.contactDetailTimeZone;

        const root = ReactDOM.createRoot(formContainer);
        root.render(<FormRenderer formJson={formJson.data} onSubmit={(formData) => handleFormSubmit(formData, serviceId, audienceId, contactDetailTimeZone, apiKey)} />);
      } catch (error) {
        // Sentry.captureReactException(error, 'Failed to fetch form');
      }
    }));
  },
};

console.log("EmbedForm has been defined:", window.EmbedForm);